import { useInterval } from '@eturi/react'
import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'

type EllipsisLoaderProps = {
	children: ReactNode
	readonly loading: boolean
	readonly className?: string
}

export const EllipsisLoader = ({ children, loading, ...props }: EllipsisLoaderProps) => {
	const [textDotIdx, setTextDotIdx] = useState(0)

	useInterval(
		() => {
			setTextDotIdx((textDotIdx + 1) % 4)
		},
		loading ? 500 : null,
	)

	// Reset the text dot index when loading is false
	useEffect(() => {
		if (!loading) setTextDotIdx(0)
	}, [loading])

	return (
		<p {...props}>
			{children}
			{loading ? ['   ', '.  ', '.. ', '...'][textDotIdx] : ''}
		</p>
	)
}
